import Component from "../../lib/component";
import {CharCounterResult} from "./char_counter_result";

export const CharCounterConfig = {
    componentTypeKey: 'CharCounter',
    baseHtmlClass: 'js--char_counter',
    selector: '.js--char_counter',

    datasetConfigKey: 'char_counter__config',
    maxCharsDatasetConfigKey: 'max_chars',
    resultIdDatasetConfigKey: 'result_id',
};

export class CharCounter extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: CharCounterConfig
        });

        this.setDatasetConfig(CharCounterConfig.datasetConfigKey);
        this.maxChars = this.getMaxCharsConfig();
        const resultElement = this.getResultElement();
        this.charCounterResult = (!!resultElement) ? (new CharCounterResult(resultElement, this)) : null;

        this.element.addEventListener('keyup', this.handleChange.bind(this));
        this.element.addEventListener('keydown', this.handleChange.bind(this));
        this.render();
    }

    render() {
        if (this.charCounterResult) this.charCounterResult.render();
    }

    handleChange(event) {
        this.render();
    }

    getCharCount() {
        return this.element.value.length;
    }

    isMaxedOut() {
        return (this.getCharCount() > this.maxChars);
    }

    getMaxCharsConfig() {
        const configValue = this.getDatasetConfigValue(CharCounterConfig.maxCharsDatasetConfigKey);
        return ((typeof configValue !== 'undefined') ? configValue : 1000);
    }

    getResultElement() {
        const elementId = this.getDatasetConfigValue(CharCounterConfig.resultIdDatasetConfigKey);
        return ((typeof elementId !== 'undefined') ? document.getElementById(elementId) : null);
    }
}